import { createApp } from "vue";
import App from "./App.vue";
import store from "./ts/store";
import axios from "axios";
import VueAxios from "vue-axios";
import { configureAxios } from "./ts/api/axiosConfiguration";
import InViewDirective from "./ts/directives/v-in-view";

configureAxios();

const app = createApp(App);

app.use(store)
app.use(VueAxios, axios);
app.directive('in-view', InViewDirective);

// Stubbing router-link as not currently included in auth app.
app.component('router-link', {
  props: ['to'],
  setup(props, { slots }) {
    return () => slots.default?.()
  }
});

app.mount("#app");
